import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"markup"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 12C22 15.5058 20.1959 18.5903 17.4654 20.3757C17.3131 20.4753 17.1579 20.5708 17 20.6622C15.5291 21.513 13.8214 22 12 22C10.1786 22 8.47087 21.513 7 20.6622C6.84207 20.5708 6.68687 20.4753 6.53456 20.3757C3.8041 18.5903 2 15.5058 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M7 20.6622C8.47087 21.513 10.1786 22 12 22C13.8214 22 15.5291 21.513 17 20.6622L15 13H9L7 20.6622Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M10.9999 9V13H12.9999V9L11.9999 8L10.9999 9Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7.0006 20.6622C8.47146 21.513 10.1792 22 12.0006 22C13.822 22 15.5297 21.513 17.0006 20.6622M7.0006 20.6622C6.84267 20.5708 6.68747 20.4753 6.53516 20.3757M7.0006 20.6622L9.0006 13H15.0006L17.0006 20.6622M17.466 20.3757C17.3137 20.4753 17.1585 20.5708 17.0006 20.6622M11.0005 13V9L12.0005 8L13.0005 9V13","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 12C22 15.5058 20.1959 18.5903 17.4654 20.3757C17.3131 20.4753 17.1579 20.5708 17 20.6622C15.5291 21.513 13.8214 22 12 22C10.1786 22 8.47087 21.513 7 20.6622C6.84207 20.5708 6.68687 20.4753 6.53456 20.3757C3.8041 18.5903 2 15.5058 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z","strokeWidth":"props.strokeWidth"}}]}]};

const Markup = Vue.extend<IconProps>({
  name: 'MarkupIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'markup',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Markup;
